export default __webpack_public_path__ + "static/why-choose-pwa-b2e4a4d06ba9fcf5948870c62bf59a8d.webp";